import { styled, MenuItem, Slider } from '@mui/material';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

export const StyledCreateVoice = styled('div')`
  padding: 0 80px;
  .MuiFormControlLabel-root {
    display: flex;
    align-items: start;
    margin-bottom: 24px;
  }
  .MuiCheckbox-root {
    padding-top: 0;
  }
  .btn-loading {
    color: #1e164e;
  }
`;

export const StyledNewAudioSlider = styled(Slider)({
  height: 6,
  padding: 0,

  '& .MuiSlider-track': {
    border: 'none',
  },

  '& .MuiSlider-thumb': {
    display: 'none',
  },

  '& .MuiSlider-rail': {
    color: COLOR.secondary[24],
  },
});

export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    font-weight: 500;
    font-size: ${(props) => props.fontSize || '16px'};
    &:focus {
      color: ${COLOR.white};
      background-color: ${COLOR.light};
      &:hover {
        background-color: ${COLOR.light};
        color: ${COLOR.white};
      }
    }
    &:hover {
      background-color: ${TRANSPARENT_COLOR.light};
      &.MuiListItemIcon-root,
      &.MuiListItemText-primary {
        color: ${COLOR.white};
      }
    }
  }
`;

export const StyledAudioPlay = styled('div')`
  display: flex;
  padding: 8px 12px 8px 12px;
  gap: 12px;
  border-radius: 12px;
  border: 1px solid ${COLOR.darkV2[16]};
  justify-content: center;
  align-items: center;
  opacity: ${({ disabledInteract }) => (disabledInteract ? 0.5 : 1)};
  background-color: ${COLOR.white};

  .button-play {
    padding: 8px;
    min-width: 10px;
    min-height: 10px;
    width: 40px;
    height: 40px;
    background: ${({ bgcolor }) => bgcolor};
    color: ${({ color }) => color};
  }

  .disabled {
    background: ${COLOR.darkV2[16]};
    color: ${COLOR.indigo[64]};
  }
`;

export const StyledAvatarInput = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 0px 0px 0px;
  .avatar {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: center;
    width: 64px;
    height: 64px;

    .avatar-img {
      width: 64px;
      height: 64px;
    }

    .icon-box {
      position: absolute;
      left: 40px;
      top: 40px;

      .icon {
        color: ${COLOR.darkV2[64]};
        width: 24px;
        height: 24px;
      }
    }
  }
`;

const TYPE_AUDIO = {
  original: 'original',
  clone: 'clone',
};

export const StyledAudioPlayerBox = styled('div')`
  background: ${({ type }) =>
    type === TYPE_AUDIO.original
      ? 'linear-gradient(135deg, #F8FAFC 0%, rgba(239, 246, 255, 0.50) 50%, rgba(224, 231, 255, 0.80) 100%)'
      : 'linear-gradient(135deg, #FFFBEB 0%, rgba(254, 252, 232, 0.50) 50%, rgba(255, 237, 212, 0.80) 100%)'};
  padding: 16px;
  border-radius: 12px;
  border: ${({ type }) =>
    type === TYPE_AUDIO.original
      ? `1px solid ${TRANSPARENT_COLOR.bgrGray}`
      : `1px solid ${COLOR.yellow[8]}`};
`;
